export const environment = {
  production: false,
  baseUrl: 'https://api.uat.pave.com.my/',
  GA_ID: 'G-E8E15ZYN48',
  Ideal_Timeout: 300,
  siteKey: '6Le4iGopAAAAAAS6LZt7vqdq9BFzbjB0Ir-zbv0A',
  dev: false,
  MAINTANCE_CHECK_DELAY: 300000,
  GOOGLE_MAPS_API_KEY: 'AIzaSyCu7NFlm-93pMSnysfeIkPsvkhhOVWrsBk',
  CHATBOT_URL: 'https://d3tkp103ku818j.cloudfront.net/',
  SECRET_KEY: '34348ef49fa5630d348ef49fa5630d74b7c6a8d93f93f',
  toastrTimeout: 5000,
  toastrTimeoutDup: 15000,
  CHATBOT_AVATAR: 'https://images.uat.pave.com.my/iDAMerdeka.png',
  INSURANCE_PRODUCT_ID: 'INS00011',
  imageBaseUrl: 'https://images.uat.pave.com.my/',
};
